// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/docs/v1/docs.proto (package mono.docs.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * DocumentType identifies the editor flavour. Matches file extension.
 *
 * @generated from enum mono.docs.v1.DocumentType
 */ export var DocumentType = /*#__PURE__*/ function(DocumentType) {
    /**
   * @generated from enum value: DOCUMENT_TYPE_UNSPECIFIED = 0;
   */ DocumentType[DocumentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DOCUMENT_TYPE_DOCX = 1;
   */ DocumentType[DocumentType["DOCX"] = 1] = "DOCX";
    /**
   * @generated from enum value: DOCUMENT_TYPE_XLSX = 2;
   */ DocumentType[DocumentType["XLSX"] = 2] = "XLSX";
    /**
   * @generated from enum value: DOCUMENT_TYPE_PPTX = 3;
   */ DocumentType[DocumentType["PPTX"] = 3] = "PPTX";
    return DocumentType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DocumentType)
proto3.util.setEnumType(DocumentType, "mono.docs.v1.DocumentType", [
    {
        no: 0,
        name: "DOCUMENT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DOCUMENT_TYPE_DOCX"
    },
    {
        no: 2,
        name: "DOCUMENT_TYPE_XLSX"
    },
    {
        no: 3,
        name: "DOCUMENT_TYPE_PPTX"
    }
]);
/**
 * @generated from message mono.docs.v1.PingRequest
 */ export class PingRequest extends Message {
    static fromBinary(bytes, options) {
        return new PingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingRequest, "runtime", proto3);
_define_property(PingRequest, "typeName", "mono.docs.v1.PingRequest");
_define_property(PingRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.docs.v1.PingResponse
 */ export class PingResponse extends Message {
    static fromBinary(bytes, options) {
        return new PingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingResponse, "runtime", proto3);
_define_property(PingResponse, "typeName", "mono.docs.v1.PingResponse");
_define_property(PingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.Document
 */ export class Document extends Message {
    static fromBinary(bytes, options) {
        return new Document().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Document().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Document().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Document, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * empty string means root
   *
   * @generated from field: string folder_id = 4;
   */ _define_property(this, "folderId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.docs.v1.DocumentType document_type = 6;
   */ _define_property(this, "documentType", 0), /**
   * @generated from field: int64 size_bytes = 7;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: int32 version_count = 8;
   */ _define_property(this, "versionCount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * Where the document's current bytes live. When the document was created
   * via the tesoro-mediated path these match the tesoro artifact's location;
   * legacy direct-MinIO docs leave them empty and consumers fall back to
   * the deterministic per-version scheme. Consumers reading the bytes
   * (zou's GetVolumeDocumentContent → baltigo ExtractDocumentText) should
   * prefer these fields over re-deriving the key client-side.
   *
   * @generated from field: string storage_bucket = 11;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 12;
   */ _define_property(this, "storageKey", ""), /**
   * True when the document was created from real bytes (uploaded or authored in
   * the editor), false when minted as an empty chat shell awaiting a fill. Lets
   * the frontend hide unfilled shells without hiding populated single-version
   * documents.
   *
   * @generated from field: bool created_with_content = 13;
   */ _define_property(this, "createdWithContent", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Document, "runtime", proto3);
_define_property(Document, "typeName", "mono.docs.v1.Document");
_define_property(Document, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "document_type",
            kind: "enum",
            T: proto3.getEnumType(DocumentType)
        },
        {
            no: 7,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_with_content",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.Folder
 */ export class Folder extends Message {
    static fromBinary(bytes, options) {
        return new Folder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Folder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Folder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Folder, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * empty string means root
   *
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Folder, "runtime", proto3);
_define_property(Folder, "typeName", "mono.docs.v1.Folder");
_define_property(Folder, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.docs.v1.DocumentVersion
 */ export class DocumentVersion extends Message {
    static fromBinary(bytes, options) {
        return new DocumentVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string restored_from_version_id = 7;
   */ _define_property(this, "restoredFromVersionId", ""), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: int32 version_number = 3;
   */ _define_property(this, "versionNumber", 0), /**
   * @generated from field: int64 size_bytes = 4;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: string created_by_user_id = 5;
   */ _define_property(this, "createdByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * WRT-02: metadata stored in pangaea (DocumentVersionGatewayService). A
   * version without a row reads as kind=working, label="", locked=false,
   * source=editor.
   *
   * @generated from field: string label = 8;
   */ _define_property(this, "label", ""), /**
   * working | named | review | final | submitted
   *
   * @generated from field: string kind = 9;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: bool locked = 10;
   */ _define_property(this, "locked", false), /**
   * editor | assist | restore | import | copy | promote | migration | system | adoption
   *
   * @generated from field: string source = 11;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string labelled_by = 12;
   */ _define_property(this, "labelledBy", ""), /**
   * @generated from field: google.protobuf.Timestamp labelled_at = 13;
   */ _define_property(this, "labelledAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentVersion, "runtime", proto3);
_define_property(DocumentVersion, "typeName", "mono.docs.v1.DocumentVersion");
_define_property(DocumentVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 7,
            name: "restored_from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "created_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "locked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "labelled_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "labelled_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ----- ListDocuments -----
 *
 * @generated from message mono.docs.v1.ListDocumentsRequest
 */ export class ListDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Folder to list. Empty string lists root documents.
   *
   * @generated from field: string folder_id = 1;
   */ _define_property(this, "folderId", ""), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * Optional name search (case-insensitive substring match).
   *
   * @generated from field: string search = 4;
   */ _define_property(this, "search", ""), /**
   * List across every folder as a flat set, ignoring folder_id. Used by surfaces
   * that show all of a user's documents wherever they live (chat resume, the
   * Artifacts tab) rather than browsing one folder at a time.
   *
   * @generated from field: bool all_folders = 5;
   */ _define_property(this, "allFolders", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsRequest, "runtime", proto3);
_define_property(ListDocumentsRequest, "typeName", "mono.docs.v1.ListDocumentsRequest");
_define_property(ListDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "all_folders",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListDocumentsResponse
 */ export class ListDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.Document documents = 1;
   */ _define_property(this, "documents", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDocumentsResponse, "runtime", proto3);
_define_property(ListDocumentsResponse, "typeName", "mono.docs.v1.ListDocumentsResponse");
_define_property(ListDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: Document,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ----- GetDocument -----
 *
 * @generated from message mono.docs.v1.GetDocumentRequest
 */ export class GetDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentRequest, "runtime", proto3);
_define_property(GetDocumentRequest, "typeName", "mono.docs.v1.GetDocumentRequest");
_define_property(GetDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentResponse
 */ export class GetDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentResponse, "runtime", proto3);
_define_property(GetDocumentResponse, "typeName", "mono.docs.v1.GetDocumentResponse");
_define_property(GetDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- CreateDocument -----
 *
 * @generated from message mono.docs.v1.CreateDocumentRequest
 */ export class CreateDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.docs.v1.DocumentType document_type = 2;
   */ _define_property(this, "documentType", 0), /**
   * Empty string = root folder.
   *
   * @generated from field: string folder_id = 3;
   */ _define_property(this, "folderId", ""), /**
   * Optional starting bytes. When empty, a blank template is created.
   *
   * @generated from field: bytes initial_bytes = 4;
   */ _define_property(this, "initialBytes", new Uint8Array(0)), /**
   * Optional idempotency key. The same caller, tenant and key always name the
   * same document: a retried create returns the document the first call made
   * instead of a second copy (an accepted chat proposal sends tenant:chat:call).
   *
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDocumentRequest, "runtime", proto3);
_define_property(CreateDocumentRequest, "typeName", "mono.docs.v1.CreateDocumentRequest");
_define_property(CreateDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "enum",
            T: proto3.getEnumType(DocumentType)
        },
        {
            no: 3,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "initial_bytes",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateDocumentResponse
 */ export class CreateDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDocumentResponse, "runtime", proto3);
_define_property(CreateDocumentResponse, "typeName", "mono.docs.v1.CreateDocumentResponse");
_define_property(CreateDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- RenameDocument -----
 *
 * @generated from message mono.docs.v1.RenameDocumentRequest
 */ export class RenameDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDocumentRequest, "runtime", proto3);
_define_property(RenameDocumentRequest, "typeName", "mono.docs.v1.RenameDocumentRequest");
_define_property(RenameDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameDocumentResponse
 */ export class RenameDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameDocumentResponse, "runtime", proto3);
_define_property(RenameDocumentResponse, "typeName", "mono.docs.v1.RenameDocumentResponse");
_define_property(RenameDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- MoveDocument -----
 *
 * @generated from message mono.docs.v1.MoveDocumentRequest
 */ export class MoveDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Empty string = root folder.
   *
   * @generated from field: string folder_id = 2;
   */ _define_property(this, "folderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveDocumentRequest, "runtime", proto3);
_define_property(MoveDocumentRequest, "typeName", "mono.docs.v1.MoveDocumentRequest");
_define_property(MoveDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.MoveDocumentResponse
 */ export class MoveDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveDocumentResponse, "runtime", proto3);
_define_property(MoveDocumentResponse, "typeName", "mono.docs.v1.MoveDocumentResponse");
_define_property(MoveDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        }
    ]));
/**
 * ----- DeleteDocument -----
 *
 * @generated from message mono.docs.v1.DeleteDocumentRequest
 */ export class DeleteDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentRequest, "runtime", proto3);
_define_property(DeleteDocumentRequest, "typeName", "mono.docs.v1.DeleteDocumentRequest");
_define_property(DeleteDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteDocumentResponse
 */ export class DeleteDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDocumentResponse, "runtime", proto3);
_define_property(DeleteDocumentResponse, "typeName", "mono.docs.v1.DeleteDocumentResponse");
_define_property(DeleteDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ----- Folder ops -----
 *
 * @generated from message mono.docs.v1.ListFoldersRequest
 */ export class ListFoldersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListFoldersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFoldersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFoldersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFoldersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty string = list root folders.
   *
   * @generated from field: string parent_id = 1;
   */ _define_property(this, "parentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFoldersRequest, "runtime", proto3);
_define_property(ListFoldersRequest, "typeName", "mono.docs.v1.ListFoldersRequest");
_define_property(ListFoldersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListFoldersResponse
 */ export class ListFoldersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListFoldersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFoldersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFoldersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFoldersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.Folder folders = 1;
   */ _define_property(this, "folders", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFoldersResponse, "runtime", proto3);
_define_property(ListFoldersResponse, "typeName", "mono.docs.v1.ListFoldersResponse");
_define_property(ListFoldersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folders",
            kind: "message",
            T: Folder,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetFolderRequest
 */ export class GetFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFolderRequest, "runtime", proto3);
_define_property(GetFolderRequest, "typeName", "mono.docs.v1.GetFolderRequest");
_define_property(GetFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetFolderResponse
 */ export class GetFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFolderResponse, "runtime", proto3);
_define_property(GetFolderResponse, "typeName", "mono.docs.v1.GetFolderResponse");
_define_property(GetFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateFolderRequest
 */ export class CreateFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * empty = root
   *
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateFolderRequest, "runtime", proto3);
_define_property(CreateFolderRequest, "typeName", "mono.docs.v1.CreateFolderRequest");
_define_property(CreateFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.CreateFolderResponse
 */ export class CreateFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateFolderResponse, "runtime", proto3);
_define_property(CreateFolderResponse, "typeName", "mono.docs.v1.CreateFolderResponse");
_define_property(CreateFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameFolderRequest
 */ export class RenameFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenameFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameFolderRequest, "runtime", proto3);
_define_property(RenameFolderRequest, "typeName", "mono.docs.v1.RenameFolderRequest");
_define_property(RenameFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RenameFolderResponse
 */ export class RenameFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenameFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenameFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenameFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenameFolderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Folder folder = 1;
   */ _define_property(this, "folder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenameFolderResponse, "runtime", proto3);
_define_property(RenameFolderResponse, "typeName", "mono.docs.v1.RenameFolderResponse");
_define_property(RenameFolderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "folder",
            kind: "message",
            T: Folder
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteFolderRequest
 */ export class DeleteFolderRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFolderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFolderRequest, "runtime", proto3);
_define_property(DeleteFolderRequest, "typeName", "mono.docs.v1.DeleteFolderRequest");
_define_property(DeleteFolderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.DeleteFolderResponse
 */ export class DeleteFolderResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFolderResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFolderResponse, "runtime", proto3);
_define_property(DeleteFolderResponse, "typeName", "mono.docs.v1.DeleteFolderResponse");
_define_property(DeleteFolderResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ----- GetEditSession -----
 *
 * @generated from message mono.docs.v1.GetEditSessionRequest
 */ export class GetEditSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEditSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEditSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEditSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEditSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * WRT-03: open this version read-only (mode view, no permissions, no
   * callback, key "<doc>-<version>-ro"; the file token serves that version).
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: bool view_only = 3;
   */ _define_property(this, "viewOnly", false), /**
   * WRT-04/05: open the editor scrolled to this section bookmark. Must match
   * ^_?spx_[0-9a-f]{32}$ (InvalidArgument otherwise). shirohige adds
   * editorConfig.actionLink = {"action":{"type":"bookmark","data":<anchor>}}
   * before signing, so the JWT covers it. Ignored for version views.
   *
   * @generated from field: string action_link_bookmark = 4;
   */ _define_property(this, "actionLinkBookmark", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEditSessionRequest, "runtime", proto3);
_define_property(GetEditSessionRequest, "typeName", "mono.docs.v1.GetEditSessionRequest");
_define_property(GetEditSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "view_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "action_link_bookmark",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetEditSessionResponse
 */ export class GetEditSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEditSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEditSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEditSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEditSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Full JSON string suitable as the `config` prop to
   * @onlyoffice/document-editor-react. Already signed with JWT.
   *
   * @generated from field: string editor_config_json = 1;
   */ _define_property(this, "editorConfigJson", ""), /**
   * Public URL of ONLYOFFICE Document Server (for DocumentEditor `documentServerUrl`).
   *
   * @generated from field: string document_server_url = 2;
   */ _define_property(this, "documentServerUrl", ""), /**
   * Document type short-form: "word", "cell", "slide".
   *
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEditSessionResponse, "runtime", proto3);
_define_property(GetEditSessionResponse, "typeName", "mono.docs.v1.GetEditSessionResponse");
_define_property(GetEditSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "editor_config_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_server_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- Versions -----
 *
 * @generated from message mono.docs.v1.ListVersionsRequest
 */ export class ListVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVersionsRequest, "runtime", proto3);
_define_property(ListVersionsRequest, "typeName", "mono.docs.v1.ListVersionsRequest");
_define_property(ListVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ListVersionsResponse
 */ export class ListVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.docs.v1.DocumentVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * The id of the version that is currently live. It is NOT necessarily the
   * highest version_number: a stale editor autosave that lost to a concurrent AI
   * apply is kept as a branch version with a higher number but is not current.
   * Clients must mark "current" by this id, not by max(version_number).
   *
   * @generated from field: string current_version_id = 2;
   */ _define_property(this, "currentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVersionsResponse, "runtime", proto3);
_define_property(ListVersionsResponse, "typeName", "mono.docs.v1.ListVersionsResponse");
_define_property(ListVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: DocumentVersion,
            repeated: true
        },
        {
            no: 2,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreVersionRequest
 */ export class RestoreVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * Optional optimistic base; empty = no check. A stale base aborts with
   * RfiSectionDocumentConflict details and writes nothing.
   *
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionRequest, "runtime", proto3);
_define_property(RestoreVersionRequest, "typeName", "mono.docs.v1.RestoreVersionRequest");
_define_property(RestoreVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreVersionResponse
 */ export class RestoreVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * Editor cache key of the new current version.
   *
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreVersionResponse, "runtime", proto3);
_define_property(RestoreVersionResponse, "typeName", "mono.docs.v1.RestoreVersionResponse");
_define_property(RestoreVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DocumentOperation is one AI-proposed edit: an action name plus free-form,
 * action-specific params. Mirrors the shanks write-to-document tool output the
 * frontend forwards on approval. `params` is an untyped struct because each
 * action has its own shape (validated by the server-side translator).
 *
 * @generated from message mono.docs.v1.DocumentOperation
 */ export class DocumentOperation extends Message {
    static fromBinary(bytes, options) {
        return new DocumentOperation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentOperation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentOperation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentOperation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string action = 1;
   */ _define_property(this, "action", ""), /**
   * @generated from field: google.protobuf.Struct params = 2;
   */ _define_property(this, "params", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentOperation, "runtime", proto3);
_define_property(DocumentOperation, "typeName", "mono.docs.v1.DocumentOperation");
_define_property(DocumentOperation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "params",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.docs.v1.ApplyDocumentOperationsRequest
 */ export class ApplyDocumentOperationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyDocumentOperationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyDocumentOperationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyDocumentOperationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyDocumentOperationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: repeated mono.docs.v1.DocumentOperation operations = 2;
   */ _define_property(this, "operations", []), /**
   * Stable identity of one approved proposal. Repeating it must not produce
   * another document version, even after a lost response or service restart.
   *
   * @generated from field: string operation_id = 3;
   */ _define_property(this, "operationId", ""), /**
   * WRT-27: refuse instead of risking co-editors' unsaved edits. When true, a
   * failed or timed-out forcesave, or a NOT_OPEN answer while users are still
   * connected, returns FAILED_PRECONDITION (connected_users in the message)
   * rather than applying to the stored bytes. When false the apply proceeds
   * after logging the failed forcesave.
   *
   * @generated from field: bool require_quiescent = 4;
   */ _define_property(this, "requireQuiescent", false), /**
   * WRT-08: unset = the service default (SHIROHIGE_AI_TRACK_CHANGES); true
   * forces tracked changes and false forces untracked, for DOCX applies with
   * Builder ops (structural-only applies are always untracked).
   *
   * @generated from field: optional bool track_changes = 5;
   */ _define_property(this, "trackChanges", void 0), /**
   * WRT-08: optimistic base. When set and it differs from the document's
   * current version id AFTER the forcesave, nothing is written and the call
   * returns Aborted with an RfiSectionDocumentConflict detail whose
   * current_version_id is the document's current version.
   *
   * @generated from field: string expected_base_version_id = 6;
   */ _define_property(this, "expectedBaseVersionId", ""), /**
   * WRT-08: author shown on the tracked revisions this apply creates
   * (e.g. "Ada via Specra Assist"). Trimmed, capped at 120 chars. Revisions
   * already in the document keep their authors. Empty = Builder default.
   *
   * @generated from field: string author = 7;
   */ _define_property(this, "author", ""), /**
   * WRT-08: honoured only for trusted service callers (X-Admin-Secret): the new
   * DocumentVersion.created_by_user_id is this user instead of the forwarded
   * principal. Ignored for browser/human principals.
   *
   * @generated from field: string acting_user_id = 8;
   */ _define_property(this, "actingUserId", ""), /**
   * Permit untracked heading structure operations (WRT-09).
   *
   * @generated from field: bool structural = 9;
   */ _define_property(this, "structural", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyDocumentOperationsRequest, "runtime", proto3);
_define_property(ApplyDocumentOperationsRequest, "typeName", "mono.docs.v1.ApplyDocumentOperationsRequest");
_define_property(ApplyDocumentOperationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "operations",
            kind: "message",
            T: DocumentOperation,
            repeated: true
        },
        {
            no: 3,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "require_quiescent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "track_changes",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 6,
            name: "expected_base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "author",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "acting_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "structural",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.StampedHeadingAnchor
 */ export class StampedHeadingAnchor extends Message {
    static fromBinary(bytes, options) {
        return new StampedHeadingAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StampedHeadingAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StampedHeadingAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StampedHeadingAnchor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 index = 1;
   */ _define_property(this, "index", 0), /**
   * @generated from field: string anchor = 2;
   */ _define_property(this, "anchor", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StampedHeadingAnchor, "runtime", proto3);
_define_property(StampedHeadingAnchor, "typeName", "mono.docs.v1.StampedHeadingAnchor");
_define_property(StampedHeadingAnchor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ApplyDocumentOperationsResponse
 */ export class ApplyDocumentOperationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyDocumentOperationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyDocumentOperationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyDocumentOperationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyDocumentOperationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The updated document metadata (with a bumped version count).
   *
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * The new ONLYOFFICE document key. The client remounts the editor on this key
   * so the Document Server reloads the freshly-written bytes instead of serving
   * its stale cache.
   *
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", ""), /**
   * Newly anchored headings, re-read from the result DOCX (WRT-09).
   *
   * @generated from field: repeated mono.docs.v1.StampedHeadingAnchor stamped = 3;
   */ _define_property(this, "stamped", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyDocumentOperationsResponse, "runtime", proto3);
_define_property(ApplyDocumentOperationsResponse, "typeName", "mono.docs.v1.ApplyDocumentOperationsResponse");
_define_property(ApplyDocumentOperationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stamped",
            kind: "message",
            T: StampedHeadingAnchor,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentTextRequest
 */ export class GetDocumentTextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentTextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * Windowed read for large documents: return the slice of the document's text
   * starting at this character (rune) offset. Defaults to 0 (the start).
   *
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * Maximum characters (runes) to return from offset. 0 applies the server
   * default window; the server also caps the maximum. Page by re-requesting with
   * offset advanced by the returned character_count.
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentTextRequest, "runtime", proto3);
_define_property(GetDocumentTextRequest, "typeName", "mono.docs.v1.GetDocumentTextRequest");
_define_property(GetDocumentTextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentTextResponse
 */ export class GetDocumentTextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentTextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The requested window of the document's text.
   *
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * Number of characters (runes) in this window.
   *
   * @generated from field: int32 character_count = 2;
   */ _define_property(this, "characterCount", 0), /**
   * Total characters (runes) in the whole document, so the caller knows how much
   * remains and whether to page further (offset + character_count < total_characters).
   *
   * @generated from field: int32 total_characters = 3;
   */ _define_property(this, "totalCharacters", 0), /**
   * The immutable version whose stored bytes produced this text.
   *
   * @generated from field: string version_id = 4;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentTextResponse, "runtime", proto3);
_define_property(GetDocumentTextResponse, "typeName", "mono.docs.v1.GetDocumentTextResponse");
_define_property(GetDocumentTextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "character_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_characters",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- GetDocumentAnalysis / GetDocumentRegionText (WRT-01) -----
 *
 * @generated from message mono.docs.v1.GetDocumentAnalysisRequest
 */ export class GetDocumentAnalysisRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentAnalysisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentAnalysisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentAnalysisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentAnalysisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * Empty = the current version.
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentAnalysisRequest, "runtime", proto3);
_define_property(GetDocumentAnalysisRequest, "typeName", "mono.docs.v1.GetDocumentAnalysisRequest");
_define_property(GetDocumentAnalysisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentAnalysisResponse
 */ export class GetDocumentAnalysisResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentAnalysisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentAnalysisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentAnalysisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentAnalysisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * officedoc.Analysis JSON (§3.4); empty when error is set.
   *
   * @generated from field: string analysis_json = 2;
   */ _define_property(this, "analysisJson", ""), /**
   * True when no stored row existed and the analysis was computed from the
   * version's stored bytes during this call.
   *
   * @generated from field: bool computed_now = 3;
   */ _define_property(this, "computedNow", false), /**
   * Non-empty when the version could not be analyzed (not a DOCX, damaged).
   *
   * @generated from field: string error = 4;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentAnalysisResponse, "runtime", proto3);
_define_property(GetDocumentAnalysisResponse, "typeName", "mono.docs.v1.GetDocumentAnalysisResponse");
_define_property(GetDocumentAnalysisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "analysis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "computed_now",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentRegionTextRequest
 */ export class GetDocumentRegionTextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentRegionTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentRegionTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentRegionTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentRegionTextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * Empty = the current version.
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * Section anchor bookmark name (^_?spx_[0-9a-f]{32}$).
   *
   * @generated from field: string anchor = 3;
   */ _define_property(this, "anchor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentRegionTextRequest, "runtime", proto3);
_define_property(GetDocumentRegionTextRequest, "typeName", "mono.docs.v1.GetDocumentRegionTextRequest");
_define_property(GetDocumentRegionTextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentRegionTextResponse
 */ export class GetDocumentRegionTextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentRegionTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentRegionTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentRegionTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentRegionTextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", ""), /**
   * @generated from field: int32 words = 2;
   */ _define_property(this, "words", 0), /**
   * @generated from field: string region_sha256 = 3;
   */ _define_property(this, "regionSha256", ""), /**
   * @generated from field: bool found = 4;
   */ _define_property(this, "found", false), /**
   * @generated from field: string version_id = 5;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentRegionTextResponse, "runtime", proto3);
_define_property(GetDocumentRegionTextResponse, "typeName", "mono.docs.v1.GetDocumentRegionTextResponse");
_define_property(GetDocumentRegionTextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "words",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "found",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- WRT-02: LabelDocumentVersion / CopyDocument / PromoteDocumentVersion / ImportDocumentVersion -----
 *
 * @generated from message mono.docs.v1.LabelDocumentVersionRequest
 */ export class LabelDocumentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new LabelDocumentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LabelDocumentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LabelDocumentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LabelDocumentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * 1-120 characters after trimming
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * named | review | final | submitted
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LabelDocumentVersionRequest, "runtime", proto3);
_define_property(LabelDocumentVersionRequest, "typeName", "mono.docs.v1.LabelDocumentVersionRequest");
_define_property(LabelDocumentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.LabelDocumentVersionResponse
 */ export class LabelDocumentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new LabelDocumentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LabelDocumentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LabelDocumentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LabelDocumentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LabelDocumentVersionResponse, "runtime", proto3);
_define_property(LabelDocumentVersionResponse, "typeName", "mono.docs.v1.LabelDocumentVersionResponse");
_define_property(LabelDocumentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: DocumentVersion
        }
    ]));
/**
 * @generated from message mono.docs.v1.CopyDocumentRequest
 */ export class CopyDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CopyDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_document_id = 1;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * empty = the source's current version
   *
   * @generated from field: string source_version_id = 2;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * empty = root
   *
   * @generated from field: string folder_id = 4;
   */ _define_property(this, "folderId", ""), /**
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CopyDocumentRequest, "runtime", proto3);
_define_property(CopyDocumentRequest, "typeName", "mono.docs.v1.CopyDocumentRequest");
_define_property(CopyDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "folder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.CopyDocumentResponse
 */ export class CopyDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CopyDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * @generated from field: string copied_version_id = 2;
   */ _define_property(this, "copiedVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CopyDocumentResponse, "runtime", proto3);
_define_property(CopyDocumentResponse, "typeName", "mono.docs.v1.CopyDocumentResponse");
_define_property(CopyDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "copied_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.PromoteDocumentVersionRequest
 */ export class PromoteDocumentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new PromoteDocumentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteDocumentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteDocumentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteDocumentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string from_document_id = 3;
   */ _define_property(this, "fromDocumentId", ""), /**
   * empty = from_document's current version
   *
   * @generated from field: string from_version_id = 4;
   */ _define_property(this, "fromVersionId", ""), /**
   * @generated from field: string operation_id = 5;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteDocumentVersionRequest, "runtime", proto3);
_define_property(PromoteDocumentVersionRequest, "typeName", "mono.docs.v1.PromoteDocumentVersionRequest");
_define_property(PromoteDocumentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.PromoteDocumentVersionResponse
 */ export class PromoteDocumentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new PromoteDocumentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteDocumentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteDocumentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteDocumentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 2;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteDocumentVersionResponse, "runtime", proto3);
_define_property(PromoteDocumentVersionResponse, "typeName", "mono.docs.v1.PromoteDocumentVersionResponse");
_define_property(PromoteDocumentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "version",
            kind: "message",
            T: DocumentVersion
        }
    ]));
/**
 * @generated from message mono.docs.v1.ImportDocumentVersionRequest
 */ export class ImportDocumentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportDocumentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDocumentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDocumentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDocumentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: bytes content = 3;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string operation_id = 4;
   */ _define_property(this, "operationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDocumentVersionRequest, "runtime", proto3);
_define_property(ImportDocumentVersionRequest, "typeName", "mono.docs.v1.ImportDocumentVersionRequest");
_define_property(ImportDocumentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ImportDocumentVersionResponse
 */ export class ImportDocumentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportDocumentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportDocumentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportDocumentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportDocumentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 2;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportDocumentVersionResponse, "runtime", proto3);
_define_property(ImportDocumentVersionResponse, "typeName", "mono.docs.v1.ImportDocumentVersionResponse");
_define_property(ImportDocumentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "version",
            kind: "message",
            T: DocumentVersion
        }
    ]));
/**
 * ----- GetDownloadLink (WRT-03) -----
 *
 * @generated from message mono.docs.v1.GetDownloadLinkRequest
 */ export class GetDownloadLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDownloadLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDownloadLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDownloadLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDownloadLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * empty = current
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: bool strip_comments = 3;
   */ _define_property(this, "stripComments", false), /**
   * Content-Disposition filename
   *
   * @generated from field: string filename = 4;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDownloadLinkRequest, "runtime", proto3);
_define_property(GetDownloadLinkRequest, "typeName", "mono.docs.v1.GetDownloadLinkRequest");
_define_property(GetDownloadLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "strip_comments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDownloadLinkResponse
 */ export class GetDownloadLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDownloadLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDownloadLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDownloadLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDownloadLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string url = 1;
   */ _define_property(this, "url", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */ _define_property(this, "expiresAt", void 0), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * sha256 of the bytes the link serves (after stripping)
   *
   * @generated from field: string sha256 = 4;
   */ _define_property(this, "sha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDownloadLinkResponse, "runtime", proto3);
_define_property(GetDownloadLinkResponse, "typeName", "mono.docs.v1.GetDownloadLinkResponse");
_define_property(GetDownloadLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- WRT-13: exact pages and export -----
 *
 * @generated from message mono.docs.v1.GetExactPageCountRequest
 */ export class GetExactPageCountRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExactPageCountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExactPageCountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExactPageCountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExactPageCountRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * empty = current
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExactPageCountRequest, "runtime", proto3);
_define_property(GetExactPageCountRequest, "typeName", "mono.docs.v1.GetExactPageCountRequest");
_define_property(GetExactPageCountRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetExactPageCountResponse
 */ export class GetExactPageCountResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExactPageCountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExactPageCountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExactPageCountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExactPageCountResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 pages = 1;
   */ _define_property(this, "pages", 0), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: google.protobuf.Timestamp measured_at = 3;
   */ _define_property(this, "measuredAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExactPageCountResponse, "runtime", proto3);
_define_property(GetExactPageCountResponse, "typeName", "mono.docs.v1.GetExactPageCountResponse");
_define_property(GetExactPageCountResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "measured_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.docs.v1.ExportDocumentVersionRequest
 */ export class ExportDocumentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExportDocumentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportDocumentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportDocumentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportDocumentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * empty = current
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * docx (docx source) | xlsx (xlsx source) | pdf (docx or xlsx source)
   *
   * @generated from field: string format = 3;
   */ _define_property(this, "format", ""), /**
   * @generated from field: bool strip_comments = 4;
   */ _define_property(this, "stripComments", false), /**
   * Content-Disposition filename; its extension is replaced by the format's
   *
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportDocumentVersionRequest, "runtime", proto3);
_define_property(ExportDocumentVersionRequest, "typeName", "mono.docs.v1.ExportDocumentVersionRequest");
_define_property(ExportDocumentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "strip_comments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ExportDocumentVersionResponse
 */ export class ExportDocumentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExportDocumentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportDocumentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportDocumentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportDocumentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * 5-minute download link
   *
   * @generated from field: string url = 1;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * sha256 of content
   *
   * @generated from field: string sha256 = 4;
   */ _define_property(this, "sha256", ""), /**
   * the exported bytes, for server-to-server callers (WRT-16 package, WRT-30 freeze)
   *
   * @generated from field: bytes content = 5;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string content_type = 6;
   */ _define_property(this, "contentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportDocumentVersionResponse, "runtime", proto3);
_define_property(ExportDocumentVersionResponse, "typeName", "mono.docs.v1.ExportDocumentVersionResponse");
_define_property(ExportDocumentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 6,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentContentRequest
 */ export class GetDocumentContentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentContentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentContentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentContentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentContentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentContentRequest, "runtime", proto3);
_define_property(GetDocumentContentRequest, "typeName", "mono.docs.v1.GetDocumentContentRequest");
_define_property(GetDocumentContentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.GetDocumentContentResponse
 */ export class GetDocumentContentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentContentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentContentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentContentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentContentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * The current version's bytes.
   *
   * @generated from field: bytes content = 2;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * The current version's id, so a reader can say which save it read.
   *
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentContentResponse, "runtime", proto3);
_define_property(GetDocumentContentResponse, "typeName", "mono.docs.v1.GetDocumentContentResponse");
_define_property(GetDocumentContentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Content is the actual shared document binary (DOCX), never a second answer store.
 *
 * @generated from message mono.docs.v1.RfiSectionDocumentSnapshot
 */ export class RfiSectionDocumentSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new RfiSectionDocumentSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSectionDocumentSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSectionDocumentSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSectionDocumentSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.Document document = 1;
   */ _define_property(this, "document", void 0), /**
   * @generated from field: mono.docs.v1.DocumentVersion version = 2;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: bytes content = 3;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string current_version_id = 4;
   */ _define_property(this, "currentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSectionDocumentSnapshot, "runtime", proto3);
_define_property(RfiSectionDocumentSnapshot, "typeName", "mono.docs.v1.RfiSectionDocumentSnapshot");
_define_property(RfiSectionDocumentSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: Document
        },
        {
            no: 2,
            name: "version",
            kind: "message",
            T: DocumentVersion
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 4,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.EnsureRfiSectionDocumentRequest
 */ export class EnsureRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiSectionDocumentRequest, "runtime", proto3);
_define_property(EnsureRfiSectionDocumentRequest, "typeName", "mono.docs.v1.EnsureRfiSectionDocumentRequest");
_define_property(EnsureRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.EnsureRfiSectionDocumentResponse
 */ export class EnsureRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiSectionDocumentResponse, "runtime", proto3);
_define_property(EnsureRfiSectionDocumentResponse, "typeName", "mono.docs.v1.EnsureRfiSectionDocumentResponse");
_define_property(EnsureRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * Empty version_id reads the current immutable snapshot. Historical versions must belong to this document.
 *
 * @generated from message mono.docs.v1.ReadRfiSectionDocumentRequest
 */ export class ReadRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadRfiSectionDocumentRequest, "runtime", proto3);
_define_property(ReadRfiSectionDocumentRequest, "typeName", "mono.docs.v1.ReadRfiSectionDocumentRequest");
_define_property(ReadRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ReadRfiSectionDocumentResponse
 */ export class ReadRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReadRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadRfiSectionDocumentResponse, "runtime", proto3);
_define_property(ReadRfiSectionDocumentResponse, "typeName", "mono.docs.v1.ReadRfiSectionDocumentResponse");
_define_property(ReadRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.docs.v1.SaveRfiSectionDocumentRequest
 */ export class SaveRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: bytes content = 3;
   */ _define_property(this, "content", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveRfiSectionDocumentRequest, "runtime", proto3);
_define_property(SaveRfiSectionDocumentRequest, "typeName", "mono.docs.v1.SaveRfiSectionDocumentRequest");
_define_property(SaveRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * Aborted + RfiSectionDocumentConflict detail means zero writes; retain the local draft and read current remotely.
 *
 * @generated from message mono.docs.v1.RfiSectionDocumentConflict
 */ export class RfiSectionDocumentConflict extends Message {
    static fromBinary(bytes, options) {
        return new RfiSectionDocumentConflict().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSectionDocumentConflict().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSectionDocumentConflict().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSectionDocumentConflict, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string current_version_id = 1;
   */ _define_property(this, "currentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSectionDocumentConflict, "runtime", proto3);
_define_property(RfiSectionDocumentConflict, "typeName", "mono.docs.v1.RfiSectionDocumentConflict");
_define_property(RfiSectionDocumentConflict, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.SaveRfiSectionDocumentResponse
 */ export class SaveRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveRfiSectionDocumentResponse, "runtime", proto3);
_define_property(SaveRfiSectionDocumentResponse, "typeName", "mono.docs.v1.SaveRfiSectionDocumentResponse");
_define_property(SaveRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreRfiSectionDocumentRequest
 */ export class RestoreRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string origin_version_id = 3;
   */ _define_property(this, "originVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreRfiSectionDocumentRequest, "runtime", proto3);
_define_property(RestoreRfiSectionDocumentRequest, "typeName", "mono.docs.v1.RestoreRfiSectionDocumentRequest");
_define_property(RestoreRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "origin_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.RestoreRfiSectionDocumentResponse
 */ export class RestoreRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreRfiSectionDocumentResponse, "runtime", proto3);
_define_property(RestoreRfiSectionDocumentResponse, "typeName", "mono.docs.v1.RestoreRfiSectionDocumentResponse");
_define_property(RestoreRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * Receipt for persisted canonical Office bytes; this is NOT proof of publication.
 * A publication verifier checks exact fields and current == base (or version for
 * an activated retry). Outward serving additionally requires a matching durable
 * Pangaea publication AND current == document_version_id.
 *
 * @generated from message mono.docs.v1.RfiAdoptionReceipt
 */ export class RfiAdoptionReceipt extends Message {
    static fromBinary(bytes, options) {
        return new RfiAdoptionReceipt().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiAdoptionReceipt().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiAdoptionReceipt().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiAdoptionReceipt, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string document_version_id = 3;
   */ _define_property(this, "documentVersionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string current_version_id = 5;
   */ _define_property(this, "currentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiAdoptionReceipt, "runtime", proto3);
_define_property(RfiAdoptionReceipt, "typeName", "mono.docs.v1.RfiAdoptionReceipt");
_define_property(RfiAdoptionReceipt, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.StageRfiAdoptionRequest
 */ export class StageRfiAdoptionRequest extends Message {
    static fromBinary(bytes, options) {
        return new StageRfiAdoptionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageRfiAdoptionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageRfiAdoptionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageRfiAdoptionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * Stable server-derived adoption UUID, scoped to the tenant, never a browser claim.
   *
   * @generated from field: string adoption_id = 3;
   */ _define_property(this, "adoptionId", ""), /**
   * accepted or edited only. Pending and rejected suggestions must not be staged.
   *
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * Reviewed DOCX bytes, including rendered saved-operation output or human edits.
   *
   * @generated from field: bytes content = 5;
   */ _define_property(this, "content", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageRfiAdoptionRequest, "runtime", proto3);
_define_property(StageRfiAdoptionRequest, "typeName", "mono.docs.v1.StageRfiAdoptionRequest");
_define_property(StageRfiAdoptionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.StageRfiAdoptionResponse
 */ export class StageRfiAdoptionResponse extends Message {
    static fromBinary(bytes, options) {
        return new StageRfiAdoptionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageRfiAdoptionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageRfiAdoptionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageRfiAdoptionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiAdoptionReceipt receipt = 1;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageRfiAdoptionResponse, "runtime", proto3);
_define_property(StageRfiAdoptionResponse, "typeName", "mono.docs.v1.StageRfiAdoptionResponse");
_define_property(StageRfiAdoptionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipt",
            kind: "message",
            T: RfiAdoptionReceipt
        }
    ]));
/**
 * @generated from message mono.docs.v1.InspectRfiAdoptionRequest
 */ export class InspectRfiAdoptionRequest extends Message {
    static fromBinary(bytes, options) {
        return new InspectRfiAdoptionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InspectRfiAdoptionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InspectRfiAdoptionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InspectRfiAdoptionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string adoption_id = 3;
   */ _define_property(this, "adoptionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(InspectRfiAdoptionRequest, "runtime", proto3);
_define_property(InspectRfiAdoptionRequest, "typeName", "mono.docs.v1.InspectRfiAdoptionRequest");
_define_property(InspectRfiAdoptionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.InspectRfiAdoptionResponse
 */ export class InspectRfiAdoptionResponse extends Message {
    static fromBinary(bytes, options) {
        return new InspectRfiAdoptionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InspectRfiAdoptionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InspectRfiAdoptionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InspectRfiAdoptionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiAdoptionReceipt receipt = 1;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(InspectRfiAdoptionResponse, "runtime", proto3);
_define_property(InspectRfiAdoptionResponse, "typeName", "mono.docs.v1.InspectRfiAdoptionResponse");
_define_property(InspectRfiAdoptionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipt",
            kind: "message",
            T: RfiAdoptionReceipt
        }
    ]));
/**
 * Call only after Pangaea atomically publishes decision, receipt and citations.
 * Aborted means a manual save won: never rewind it or outward-serve this receipt.
 *
 * @generated from message mono.docs.v1.ActivateRfiAdoptionRequest
 */ export class ActivateRfiAdoptionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ActivateRfiAdoptionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateRfiAdoptionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateRfiAdoptionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateRfiAdoptionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 2;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string adoption_id = 3;
   */ _define_property(this, "adoptionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateRfiAdoptionRequest, "runtime", proto3);
_define_property(ActivateRfiAdoptionRequest, "typeName", "mono.docs.v1.ActivateRfiAdoptionRequest");
_define_property(ActivateRfiAdoptionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ActivateRfiAdoptionResponse
 */ export class ActivateRfiAdoptionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ActivateRfiAdoptionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActivateRfiAdoptionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActivateRfiAdoptionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActivateRfiAdoptionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiAdoptionReceipt receipt = 1;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActivateRfiAdoptionResponse, "runtime", proto3);
_define_property(ActivateRfiAdoptionResponse, "typeName", "mono.docs.v1.ActivateRfiAdoptionResponse");
_define_property(ActivateRfiAdoptionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipt",
            kind: "message",
            T: RfiAdoptionReceipt
        }
    ]));
/**
 * @generated from message mono.docs.v1.CheckDocumentReadsRequest
 */ export class CheckDocumentReadsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckDocumentReadsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckDocumentReadsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckDocumentReadsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckDocumentReadsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string document_ids = 1;
   */ _define_property(this, "documentIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckDocumentReadsRequest, "runtime", proto3);
_define_property(CheckDocumentReadsRequest, "typeName", "mono.docs.v1.CheckDocumentReadsRequest");
_define_property(CheckDocumentReadsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.docs.v1.CheckDocumentReadsResponse
 */ export class CheckDocumentReadsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckDocumentReadsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckDocumentReadsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckDocumentReadsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckDocumentReadsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string allowed = 1;
   */ _define_property(this, "allowed", []), /**
   * @generated from field: repeated string denied = 2;
   */ _define_property(this, "denied", []), /**
   * @generated from field: repeated string missing = 3;
   */ _define_property(this, "missing", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckDocumentReadsResponse, "runtime", proto3);
_define_property(CheckDocumentReadsResponse, "typeName", "mono.docs.v1.CheckDocumentReadsResponse");
_define_property(CheckDocumentReadsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "allowed",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "denied",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "missing",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ----- OPS-14: forcesave -----
 *
 * @generated from message mono.docs.v1.ForceSaveDocumentRequest
 */ export class ForceSaveDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ForceSaveDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ForceSaveDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ForceSaveDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ForceSaveDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional; when set it must equal the caller's tenant
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * idempotency/correlation id echoed as the command's userdata; empty = generated
   *
   * @generated from field: string operation_id = 3;
   */ _define_property(this, "operationId", ""), /**
   * wait for the save callback, ms; 0 = 15000
   *
   * @generated from field: int32 timeout_ms = 4;
   */ _define_property(this, "timeoutMs", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ForceSaveDocumentRequest, "runtime", proto3);
_define_property(ForceSaveDocumentRequest, "typeName", "mono.docs.v1.ForceSaveDocumentRequest");
_define_property(ForceSaveDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "operation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "timeout_ms",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.ForceSaveDocumentResponse
 */ export class ForceSaveDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ForceSaveDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ForceSaveDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ForceSaveDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ForceSaveDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * SAVED | NO_CHANGES | NOT_OPEN
   *
   * @generated from field: string outcome = 1;
   */ _define_property(this, "outcome", ""), /**
   * the document's current version after the call
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * people connected to the session (0 when NOT_OPEN)
   *
   * @generated from field: int32 connected_users = 3;
   */ _define_property(this, "connectedUsers", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ForceSaveDocumentResponse, "runtime", proto3);
_define_property(ForceSaveDocumentResponse, "typeName", "mono.docs.v1.ForceSaveDocumentResponse");
_define_property(ForceSaveDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "connected_users",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ----- WRT-23: capabilities -----
 *
 * @generated from message mono.docs.v1.GetDocumentCapabilitiesRequest
 */ export class GetDocumentCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentCapabilitiesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentCapabilitiesRequest, "runtime", proto3);
_define_property(GetDocumentCapabilitiesRequest, "typeName", "mono.docs.v1.GetDocumentCapabilitiesRequest");
_define_property(GetDocumentCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.docs.v1.GetDocumentCapabilitiesResponse
 */ export class GetDocumentCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDocumentCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDocumentCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDocumentCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDocumentCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * AI DOCX applies land as tracked changes (SHIROHIGE_AI_TRACK_CHANGES)
   *
   * @generated from field: bool ai_track_changes = 1;
   */ _define_property(this, "aiTrackChanges", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDocumentCapabilitiesResponse, "runtime", proto3);
_define_property(GetDocumentCapabilitiesResponse, "typeName", "mono.docs.v1.GetDocumentCapabilitiesResponse");
_define_property(GetDocumentCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ai_track_changes",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.docs.v1.BatchGetDocumentsRequest
 */ export class BatchGetDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new BatchGetDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchGetDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchGetDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchGetDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * UUIDs; any malformed ID rejects the entire request.
   *
   * @generated from field: repeated string ids = 1;
   */ _define_property(this, "ids", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchGetDocumentsRequest, "runtime", proto3);
_define_property(BatchGetDocumentsRequest, "typeName", "mono.docs.v1.BatchGetDocumentsRequest");
_define_property(BatchGetDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * Metadata only: no document content, storage keys or download links.
 *
 * @generated from message mono.docs.v1.DocumentMetadata
 */ export class DocumentMetadata extends Message {
    static fromBinary(bytes, options) {
        return new DocumentMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version_count = 2;
   */ _define_property(this, "versionCount", 0), /**
   * empty when no current version exists
   *
   * @generated from field: string current_version_id = 3;
   */ _define_property(this, "currentVersionId", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DocumentMetadata, "runtime", proto3);
_define_property(DocumentMetadata, "typeName", "mono.docs.v1.DocumentMetadata");
_define_property(DocumentMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.docs.v1.BatchGetDocumentsResponse
 */ export class BatchGetDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new BatchGetDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchGetDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchGetDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchGetDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Unordered, unique live documents in the principal's tenant. Missing,
   * deleted and foreign-tenant IDs are omitted. Empty IDs returns no rows.
   *
   * @generated from field: repeated mono.docs.v1.DocumentMetadata documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchGetDocumentsResponse, "runtime", proto3);
_define_property(BatchGetDocumentsResponse, "typeName", "mono.docs.v1.BatchGetDocumentsResponse");
_define_property(BatchGetDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: DocumentMetadata,
            repeated: true
        }
    ]));
